import _extends from '@babel/runtime/helpers/esm/extends';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _toArray from '@babel/runtime/helpers/esm/toArray';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'react-dates/initialize';
import { DayPickerSingleDateController, SingleDatePickerPhrases } from 'react-dates';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import ChevronLeft from '@elliemae/ds-icons/ChevronLeft';
import { renderMonthElement } from '../DatePickerRenderMonth/DatePickerRenderMonth.js';
import Navigation from '../DatePickerNavigation/DatePickerNavigation.js';
import Day from '../DatePickerDay/DatePickerDay.js';
import '@elliemae/ds-icons/ChevronDoubleLeft';
import '@elliemae/ds-icons/ChevronDoubleRight';
import '@elliemae/ds-basic/Grid';
import '@elliemae/ds-icons/ChevronRight';
import '@elliemae/ds-basic/Icon';
import '../../prop-types-8c5debac.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var _convertPropToCssClas = convertPropToCssClassName('datepicker-range'),
    classNameElement = _convertPropToCssClas.classNameElement,
    classNameBlock = _convertPropToCssClas.classNameBlock;

var DSDatePickerController = /*#__PURE__*/function (_React$Component) {
  _inherits(DSDatePickerController, _React$Component);

  var _super = _createSuper(DSDatePickerController);

  // eslint-disable-next-line react/static-property-placement
  function DSDatePickerController(props) {
    var _this;

    _classCallCheck(this, DSDatePickerController);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {});

    _defineProperty(_assertThisInitialized(_this), "handleMouseUp", function () {
      var focusedElement = document.activeElement;
      focusedElement.blur();
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (event) {
      var _document$getElements = document.getElementsByClassName('CalendarMonthGrid_month__horizontal')[1].getElementsByClassName('CalendarDay'),
          _document$getElements2 = _toArray(_document$getElements),
          firstDay = _document$getElements2[0],
          restOfDays = _document$getElements2.slice(1);

      var _restOfDays$slice = restOfDays.slice(-1),
          _restOfDays$slice2 = _slicedToArray(_restOfDays$slice, 1),
          lastDay = _restOfDays$slice2[0];

      var onClickEscape = _this.props.onClickEscape;

      switch (event.key) {
        case 'Home':
          firstDay.focus();
          break;

        case 'End':
          lastDay.focus();
          break;

        case 'Escape':
          onClickEscape();
          break;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getSafeValue", function () {
      var _this$props = _this.props,
          value = _this$props.value,
          date = _this$props.date,
          defaultValue = _this$props.defaultValue;
      var selectedDate = _this.state.selectedDate;

      if (value) {
        return moment(value);
      }

      if (date) {
        return moment(date);
      }

      if (defaultValue) {
        return moment(defaultValue);
      }

      if (selectedDate) {
        return moment(selectedDate);
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "isControlled", function () {
      var _this$props2 = _this.props,
          value = _this$props2.value,
          date = _this$props2.date;
      return Boolean(value) || Boolean(date);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDateChange", function (date) {
      var _this$props3 = _this.props,
          readOnly = _this$props3.readOnly,
          onDateChange = _this$props3.onDateChange,
          onChange = _this$props3.onChange;

      if (!readOnly) {
        if (!_this.isControlled()) {
          _this.setState({
            selectedDate: date
          });
        }

        onDateChange(date);
        onChange(date);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (dataInput) {
      var _this$props4 = _this.props,
          onDateChange = _this$props4.onDateChange,
          onChange = _this$props4.onChange;
      var momentvalue = moment(dataInput.target.value);

      _this.setState({
        selectedDate: momentvalue
      });

      onDateChange(momentvalue);
      onChange(momentvalue);
    });

    _defineProperty(_assertThisInitialized(_this), "handleNavClick", function (date, nav) {
      var _document$getElements3 = document.getElementsByClassName('DayPickerNavigation_button'),
          _document$getElements4 = _slicedToArray(_document$getElements3, 2),
          prev = _document$getElements4[0],
          next = _document$getElements4[1];

      var _this$props5 = _this.props,
          onPrevMonthClick = _this$props5.onPrevMonthClick,
          onNextMonthClick = _this$props5.onNextMonthClick;

      if (nav === 'prev') {
        prev.focus();
        onPrevMonthClick(date);
      } else {
        next === null || next === void 0 ? void 0 : next.focus();
        onNextMonthClick(date);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "insideBlur", function (event) {
      if (!event.currentTarget.contains(event.relatedTarget)) {
        _this.props.onClose();
      }
    });

    _this.state = {
      selectedDate: _this.getSafeValue()
    };
    _this.firstFocusableItem = /*#__PURE__*/React.createRef();
    return _this;
  } // eslint-disable-next-line react/state-in-constructor


  _createClass(DSDatePickerController, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.datePicker.addEventListener('mouseup', this.handleMouseUp, false);
      document.addEventListener('keydown', this.handleKeyDown, false);
      setTimeout(function () {
        if (_this2.datePicker) {
          var _this2$datePicker$get = _this2.datePicker.getElementsByClassName('CalendarDay__selected'),
              _this2$datePicker$get2 = _slicedToArray(_this2$datePicker$get, 1),
              calendarDaySelected = _this2$datePicker$get2[0];

          if (calendarDaySelected) calendarDaySelected === null || calendarDaySelected === void 0 ? void 0 : calendarDaySelected.focus();else _this2.firstFocusableItem.current.closest('.DayPickerNavigation_button').focus();
        }
      }, 400);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.datePicker.removeEventListener('mouseup', this.handleMouseUp, false);
      document.removeEventListener('keydown', this.handleKeyDown, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props6 = this.props,
          numberOfMonths = _this$props6.numberOfMonths,
          enableOutsideDays = _this$props6.enableOutsideDays,
          transitionDuration = _this$props6.transitionDuration,
          initialVisibleMonth = _this$props6.initialVisibleMonth,
          firstDayOfWeek = _this$props6.firstDayOfWeek,
          keepOpenOnDateSelect = _this$props6.keepOpenOnDateSelect,
          hideKeyboardShortcutsPanel = _this$props6.hideKeyboardShortcutsPanel,
          onClose = _this$props6.onClose,
          phrases = _this$props6.phrases,
          displayFormatDay = _this$props6.displayFormatDay,
          isDayBlocked = _this$props6.isDayBlocked,
          isOutsideRange = _this$props6.isOutsideRange,
          isDayHighlighted = _this$props6.isDayHighlighted,
          onOutsideClick = _this$props6.onOutsideClick,
          key = _this$props6.key,
          calendarProps = _this$props6.calendarProps;
      var safedate = this.getSafeValue();
      var safeinitialMonth = safedate && safedate.isValid() ? function () {
        return safedate;
      } : function () {
        return initialVisibleMonth;
      };
      return /*#__PURE__*/React.createElement("div", {
        onBlur: this.insideBlur
      }, /*#__PURE__*/React.createElement("div", _extends({
        ref: function ref(elem) {
          _this3.datePicker = elem;
        },
        className: classNameBlock('wrapper-day-picker-single-date-controller')
      }, calendarProps, {
        "data-testid": "calendar-wrapper"
      }), /*#__PURE__*/React.createElement(DayPickerSingleDateController, {
        key: key,
        date: safedate,
        enableOutsideDays: enableOutsideDays,
        firstDayOfWeek: firstDayOfWeek,
        focused: true,
        hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
        initialVisibleMonth: safeinitialMonth,
        isDayBlocked: isDayBlocked,
        isDayHighlighted: isDayHighlighted,
        isOutsideRange: isOutsideRange,
        keepOpenOnDateSelect: keepOpenOnDateSelect,
        navNext: /*#__PURE__*/React.createElement(Navigation, {
          className: classNameElement('navigation-next')
        }),
        navPrev: /*#__PURE__*/React.createElement(Navigation, {
          className: classNameElement('navigation-prev'),
          icon: ChevronLeft,
          innerRef: this.firstFocusableItem
        }),
        renderMonthElement: renderMonthElement,
        numberOfMonths: numberOfMonths,
        onClose: onClose,
        onDateChange: this.handleDateChange,
        onFocusChange: this.handleFocus,
        onNextMonthClick: function onNextMonthClick(e) {
          _this3.handleNavClick(e, 'next');
        },
        onOutsideClick: onOutsideClick,
        onPrevMonthClick: function onPrevMonthClick(e) {
          _this3.handleNavClick(e, 'prev');
        },
        phrases: phrases,
        renderDayContents: function renderDayContents(date) {
          return /*#__PURE__*/React.createElement(Day, {
            className: classNameElement('day-contents'),
            date: date.format(displayFormatDay)
          });
        },
        transitionDuration: transitionDuration,
        onTab: function onTab(e) {
          if (e.target.classList.contains('CalendarDay')) {
            e.preventDefault();
            onClose();
          }
        }
      })));
    }
  }]);

  return DSDatePickerController;
}(React.Component);

_defineProperty(DSDatePickerController, "defaultProps", {
  date: '',
  value: '',
  enableOutsideDays: false,
  initialVisibleMonth: moment(),
  firstDayOfWeek: 0,
  keepOpenOnDateSelect: true,
  hideKeyboardShortcutsPanel: true,
  onPrevMonthClick: function onPrevMonthClick() {
    return null;
  },
  onNextMonthClick: function onNextMonthClick() {
    return null;
  },
  onClose: function onClose() {
    return null;
  },
  onChange: function onChange() {
    return null;
  },
  onClickEscape: function onClickEscape() {
    return null;
  },
  onDateChange: function onDateChange() {
    return null;
  },
  phrases: SingleDatePickerPhrases,
  // displayFormat: 'L',
  displayFormatDay: 'D',
  transitionDuration: 0,
  // verticalSpacing: 0,
  isDayBlocked: function isDayBlocked() {
    return false;
  },
  isOutsideRange: function isOutsideRange() {
    return false;
  },
  isDayHighlighted: function isDayHighlighted() {
    return false;
  },
  numberOfMonths: 1
});
DSDatePickerController.propTypes = {
  date: PropTypes.instanceOf(Date, moment),
  value: PropTypes.oneOf(PropTypes.instanceOf(Date), PropTypes.instanceOf(moment)),
  enableOutsideDays: PropTypes.bool,
  initialVisibleMonth: PropTypes.instanceOf(Date, moment),
  firstDayOfWeek: PropTypes.number,
  keepOpenOnDateSelect: PropTypes.bool,
  hideKeyboardShortcutsPanel: PropTypes.bool,
  onPrevMonthClick: PropTypes.func,
  onNextMonthClick: PropTypes.func,
  onClose: PropTypes.func,
  onClickEscape: PropTypes.func,
  onChange: PropTypes.func,
  onDateChange: PropTypes.func,
  phrases: SingleDatePickerPhrases,
  // displayFormat: PropTypes.string,
  displayFormatDay: PropTypes.string,
  transitionDuration: PropTypes.number,
  // verticalSpacing: PropTypes.number,
  isDayBlocked: PropTypes.func,
  isOutsideRange: PropTypes.func,
  isDayHighlighted: PropTypes.func,
  numberOfMonths: PropTypes.number
};
DSDatePickerController.defaultProps = {
  date: '',
  value: '',
  enableOutsideDays: false,
  initialVisibleMonth: moment(),
  firstDayOfWeek: 0,
  keepOpenOnDateSelect: true,
  hideKeyboardShortcutsPanel: true,
  onPrevMonthClick: function onPrevMonthClick() {
    return null;
  },
  onNextMonthClick: function onNextMonthClick() {
    return null;
  },
  onClose: function onClose() {
    return null;
  },
  onClickEscape: function onClickEscape() {
    return null;
  },
  onChange: function onChange() {
    return null;
  },
  onDateChange: function onDateChange() {
    return null;
  },
  phrases: PropTypes.shape({
    calendarLabel: PropTypes.string,
    closeDatePicker: PropTypes.string,
    clearDates: PropTypes.string,
    focusStartDate: PropTypes.string,
    jumpToPrevMonth: PropTypes.string,
    jumpToNextMonth: PropTypes.string,
    keyboardShortcuts: PropTypes.string,
    showKeyboardShortcutsPanel: PropTypes.string,
    hideKeyboardShortcutsPanel: PropTypes.string,
    openThisPanel: PropTypes.string,
    enterKey: PropTypes.string,
    leftArrowRightArrow: PropTypes.string,
    upArrowDownArrow: PropTypes.string,
    pageUpPageDown: PropTypes.string,
    homeEnd: PropTypes.string,
    escape: PropTypes.string,
    questionMark: PropTypes.string,
    selectFocusedDate: PropTypes.string,
    moveFocusByOneDay: PropTypes.string,
    moveFocusByOneWeek: PropTypes.string,
    moveFocusByOneMonth: PropTypes.string,
    moveFocustoStartAndEndOfWeek: PropTypes.string,
    returnFocusToInput: PropTypes.string,
    keyboardNavigationInstructions: PropTypes.string,
    chooseAvailableStartDate: PropTypes.func,
    chooseAvailableEndDate: PropTypes.func,
    dateIsUnavailable: PropTypes.func,
    dateIsSelected: PropTypes.func
  }),
  // displayFormat: 'L',
  displayFormatDay: 'D',
  transitionDuration: 0,
  // verticalSpacing: 0,
  isDayBlocked: function isDayBlocked() {
    return false;
  },
  isOutsideRange: function isOutsideRange() {
    return false;
  },
  isDayHighlighted: function isDayHighlighted() {
    return false;
  },
  numberOfMonths: 1
};

export default DSDatePickerController;
//# sourceMappingURL=DatePickerController.js.map
